import i18n from 'i18n.js';
import { isNotNullish } from 'utils/nullish';
import { CsvUtil } from 'utils/csv-util';
import { ze } from 'utils/zhEn';

export const VmTypeInt = Object.freeze({
  ALL: 0,
  REAL_DEVICE: 1,
  EMULATOR: 2,
  CLOUD_GAMING: 3,
  PLAYCOVER: 4,
});

const androidVmTypeList = [
  VmTypeInt.REAL_DEVICE,
  VmTypeInt.EMULATOR,
  VmTypeInt.CLOUD_GAMING,
];

const VM_DEVICE_BRAND_TO_LABEL = Object.freeze({
  BlueStacks: ze('蓝叠模拟器', 'BlueStacks'),
  GameLoop: ze('GameLoop', 'GameLoop'),
  Genymotion: ze('Genymotion', 'Genymotion'),
  LDPlayer: ze('雷电模拟器', 'LDPlayer'),
  MEmu: ze('逍遥模拟器', 'MEmu'),
  MuMu: ze('MuMu模拟器', 'MuMu'),
  nox: ze('夜神模拟器', 'nox'),
  TencentGameAssist: ze('腾讯手游助手', 'TencentGameAssist'),
});

const allOptions = Object.values(VmTypeInt)
  .map(x => ({
    label: i18n.t(`vmTypeOptions.${x}`),
    value: x,
  }));

const androidOptions = allOptions.filter(x => androidVmTypeList.includes(x.value));

export const VmTypeUtil = Object.freeze({
  getAndroidOptions() {
    return androidOptions;
  },

  toI18n(vmTypeInt) {
    const tKey = `vmTypeOptions.${vmTypeInt}`;
    return i18n.exists(tKey) ? i18n.t(tKey) : vmTypeInt;
  },

  vmSelectValueToVmTypeList(dashboardVmSelectValue) {
    return CsvUtil.singleLineParse(dashboardVmSelectValue).filter(x => x.trim()).map(x => Number(x));
  },

  vmTypeListToVmSelectValue(vmTypeList) {
    return CsvUtil.singleLineStringify(vmTypeList);
  },

  getVmDeviceBrandBucketKeyDict() {
    return VM_DEVICE_BRAND_TO_LABEL;
  },
});
